import { render, staticRenderFns } from "./currencyModal.vue?vue&type=template&id=70b637ef&scoped=true&"
import script from "./currencyModal.vue?vue&type=script&lang=js&"
export * from "./currencyModal.vue?vue&type=script&lang=js&"
import style0 from "./currencyModal.vue?vue&type=style&index=0&id=70b637ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b637ef",
  null
  
)

export default component.exports